export default "__VITE_ASSET__Bw8fuT2c__"